import { createRouter, createWebHistory } from 'vue-router'

export const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: () => ({ top: 0 }),
  routes: [
    { path: '/', component: () => import('@/views/DashboardView.vue'), meta: { scopes: ['dsp.cases:read'] } },
    {
      path: '/cases',
      component: () => import('@/views/CasesView.vue'),
      meta: { scopes: ['dsp.cases:read'] },
    },
    {
      path: '/cases/:id',
      component: () => import('@/views/CaseDetailView.vue'),
      meta: { scopes: ['dsp.cases:read'] },
    },
    {
      path: '/tasks',
      component: () => import('@/views/TasksView.vue'),
      meta: { scopes: ['dsp.tasks:read'] },
    },
    {
      path: '/customers',
      component: () => import('@/views/CustomersView.vue'),
      meta: { scopes: ['dsp.customers:read'] },
    },
    {
      path: '/events',
      component: () => import('@/views/EventsView.vue'),
      meta: { scopes: ['dsp.events:read'] },
    },
    {
      path: '/automation',
      component: () => import('@/views/AutomationView.vue'),
      meta: { scopes: ['dsp.playbooks:manage'] },
    },
    {
      path: '/runs',
      component: () => import('@/views/RunsView.vue'),
      meta: { scopes: ['dsp.automation:read'] },
    },
    {
      path: '/communications',
      component: () => import('@/views/CommunicationsView.vue'),
      meta: { scopes: ['dsp.communications:read'] },
    },
    {
      path: '/integrations',
      component: () => import('@/views/IntegrationsView.vue'),
      meta: { scopes: ['dsp.sources:manage', 'dsp.webhooks:manage', 'dsp.webhooks:read'] },
    },
    {
      path: '/policies',
      component: () => import('@/views/PoliciesView.vue'),
      meta: { scopes: ['dsp.playbooks:manage'] },
    },
    {
      path: '/settings',
      component: () => import('@/views/SettingsView.vue'),
      meta: {
        scopes: [
          'dsp.credentials:read',
          'dsp.credentials:write',
          'dsp.playbooks:manage',
          'dsp.audit:read',
          'dsp.usage:read',
        ],
      },
    },
    { path: '/:pathMatch(.*)*', component: () => import('@/views/NotFoundView.vue') },
  ],
})
